// removed by extract-text-webpack-plugin
module.exports = {"tab-wrapper-small":"tab-wrapper-small","product-wrapper":"product-wrapper","product-partnum-flex":"product-partnum-flex","ant-col-24":"ant-col-24","ant-form-item-label":"ant-form-item-label","ant-col-xl-24":"ant-col-xl-24","ant-form-vertical":"ant-form-vertical"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DibbsTabs/pricingTab.scss
// module id = 750
// module chunks = 1